// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:43:57

export default {
  "id": "fnf-2-player",
  "slug": "fnf-2-player",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/151e89092f5a441088efc3f2e6c07e3e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/151e89092f5a441088efc3f2e6c07e3e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "FNF 2 Player",
      "description": "FNF 2 Player allows two players to play at the same time. Players can compete with each other by choosing the characters they want. The difficulty level can be determined by the music, thus appealing to all types of players.\n\nGame Modes: \n\n- Story Mode: You fight with new characters weekly.\n- Freeplay Mode: You can play by choosing the song you want.\n- 2 Player Mode: It's time to duel with your friend.",
      "instructions": "Controls: The first player uses the \"ARROW KEYS\", while the second player uses the \"W, A, S, D\" keys.\n\nGame Purpose: To defeat your opponent by pressing the arrows that appear on the screen at the right time. While correct moves increase your score, mistakes cause a loss of points. You should hold down the button according to the length of the arrow for long arrows.",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "1player",
        "2d",
        "2players",
        "music",
        "party"
      ]
    },
    "zh-CN": {
      "title": "FNF 双人模式",
      "description": "FNF 2 Player 允许两名玩家同时进行游戏。玩家可以通过选择他们想要的角色来相互竞争。难度级别可以通过音乐来决定，因此吸引所有类型的玩家。\n\n游戏模式：\n\n- 故事模式：你每周与新的角色战斗。\n- 自由模式：你可以选择你想要的曲目进行游戏。\n- 双人模式：是时候和你的朋友决斗了。",
      "instructions": "操作说明：第一位玩家使用“箭头键”，第二位玩家使用“W、A、S、D”键。\n\n游戏目的：通过在屏幕上正确按下出现的箭头来击败对手。正确的操作会增加你的分数，而错误会导致分数减少。对于长箭头，你应该根据箭头的长度按住按钮。",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "2D",
        "2玩家",
        "音乐",
        "派对"
      ]
    },
    "zh-TW": {
      "title": "FNF 2人遊戲",
      "description": "FNF 2 Player 允許兩位玩家同時遊玩。玩家可以選擇他們想要的角色來相互競爭。難度等級可以通過音樂來決定，因此吸引所有類型的玩家。\n\n遊戲模式：\n\n- 故事模式：你將每週與新角色戰鬥。\n- 自由模式：你可以選擇你想要的歌來遊玩。\n- 兩人模式：是時候與你的朋友決鬥了。",
      "instructions": "控制方式：第一位玩家使用“方向鍵”，而第二位玩家使用“W、A、S、D”鍵。\n\n遊戲目的：透過在屏幕上出現的時間點按箭頭來擊敗對手。正確的動作可以增加你的得分，而錯誤則會造成分數減少。對於長箭頭，你應該根據箭頭的長度按住按鍵。",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "2D",
        "2玩家",
        "音樂",
        "盡頭"
      ]
    },
    "zh-HK": {
      "title": "FNF 2人玩",
      "description": "FNF 2 Player 允許兩位玩家同時遊戲。玩家可以選擇他們想要的角色來互相競賽。難度等級可透過音樂來確定，因此適合各類型玩家。\n\n遊戲模式：\n\n- 傳說模式：你將每週與新角色作戰。\n- 自由模式：你可以選擇你想玩的歌曲。\n- 2 Player 模式：是時候與你的朋友一決高下了。",
      "instructions": "控制：第一玩家使用「方向鍵」，第二玩家使用「W, A, S, D」鍵。\n\n遊戲目的：透過在屏幕上出現的箭頭恰當時機按壓，擊敗對手。正確的操作會增加你的分數，而錯誤則會減少分數。對於長箭頭，應按住按鈕直至箭頭的長度。",
      "genres": [
        "靈巧度",
        "隨意"
      ],
      "tags": [
        "1人玩",
        "2D",
        "2人玩",
        "音樂",
        "派對"
      ]
    },
    "ja": {
      "title": "FNF 2プレイヤー",
      "description": "FNF 2 Playerは、二人が同時にプレイできるように設計されています。プレイヤーは自分たちの選んだキャラクターで他のプレイヤーと競い合うことができます。難易度は音楽で決定されるため、様々なプレイヤーに魅力的です。\n\nゲームモード：\n\n- ストーリーモード：週に新しいキャラクターで戦います。\n- フリーplayモード：好きな曲を選んでプレイできます。\n- 2 Playerモード：友達とのデュエルの時間です。",
      "instructions": "コントロール: 第1プレイヤーは「矢印キー」を使用し、第2プレイヤーは「W、A、S、D」キーを使用します。\n\nゲーム目的: スクリーンに表示される矢印を正しいタイミングで押すことで相手を倒します。正しい動作は得点を増やしますが、ミスはポイントの減少につながります。長い矢印の場合、ボタンをその長さに応じて押下してください。",
      "genres": [
        "アギリティ",
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "2プレイヤー",
        "音楽",
        "パーティー"
      ]
    },
    "ko": {
      "title": "FNF 2 플레이어",
      "description": "FNF 2 Player는 두 명의 플레이어가 동시에 플레이할 수 있습니다. 플레이어들은 원하는 캐릭터를 선택하여 서로 경쟁할 수 있습니다. 난이도는 음악에 따라 결정되어 모든 유형의 플레이어에게 인기가 있습니다.\n\n게임 모드:\n\n- 스토리 모드: 주간에 새로운 캐릭터와 싸우세요.\n- 프리플레이 모드: 원하는 곡을 선택하여 플레이하세요.\n- 2 Player 모드: 친구와 대결하는 시간입니다.",
      "instructions": "컨트롤: 첫 번째 플레이어는 \"방향키\"를 사용하며, 두 번째 플레이어는 \"W, A, S, D\" 키를 사용합니다.\n\n게임 목적: 화면에 나타나는 방향키를 적절한 시간에 누르면 상대를 물리치는 게임입니다. 올바른 움직임은 점수를 증가시키지만, 실수는 점수를 떨어뜨립니다. 장箭頭의 길이에 따라 버튼을 누른 상태를 유지해야 합니다.",
      "genres": [
        "약간",
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "2플레이어",
        "음악",
        "파티"
      ]
    },
    "fr": {
      "title": "FNF 2Joueur",
      "description": "FNF 2 Player permet à deux joueurs de jouer en même temps. Les joueurs peuvent s'affronter en choisissant les personnages qu'ils veulent. Le niveau de difficulté peut être déterminé par la musique, ce qui attire tous les types de joueurs.\n\nModes de jeu :\n\n- Mode Histoire : Vous combattez avec de nouveaux personnages chaque semaine.\n- Mode Libre : Vous pouvez jouer en choisissant la chanson que vous voulez.\n- Mode 2 Joueurs : C'est le temps de s'affronter avec votre ami.",
      "instructions": "Contrôles : Le premier joueur utilise les \"Touches flèches\", tandis que le second joueur utilise les touches \"W, A, S, D\".\n\nObjectif du jeu : Défaire votre adversaire en appuyant sur les flèches qui apparaissent à l'écran au bon moment. Alors que les mouvements corrects augmentent votre score, les erreurs entraînent une perte de points. Vous devez maintenir le bouton enfoncé pendant la durée de la flèche pour les flèches longues.",
      "genres": [
        "Agilité",
        "Loisir"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "2 joueurs",
        "musique",
        "fête"
      ]
    }
  }
};
